import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { IAttachmentFilter } from "../models/filters/attachmentFilter";
import { IAttachmentForm } from "../models/forms/attachmentForm";
import { IAttachmentPDTO } from "../models/dtos/attachmentPDTO";

// Service for Attachment operations
export default class AttachmentService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/Attachment";

    protected static override  getUrlFilter<F extends IAttachmentFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.boarId != undefined)
                url += `&BoardId=${filter.boarId}`;

            if(filter.groupeMountingId != undefined)
                url += `&GroupeMountingId=${filter.groupeMountingId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IAttachmentForm):IAttachmentPDTO {
        const dto = super.toDTO(obj) as IAttachmentPDTO;
        return dto;
    }
}